import React from "react";
import { Card, Grid, CircularProgress } from "@mui/material";
import VuiBox from "components/VuiBox";
import VuiTypography from "components/VuiTypography";
import VuiProgress from "components/VuiProgress";
import colors from "assets/theme/base/colors";
import rgba from "assets/theme/functions/rgba";
import linearGradient from "assets/theme/functions/linearGradient";
import { IoOpenOutline } from "react-icons/io5";
import useCommon from "hooks/useCommon";

function ReferralTracking({
  title = "Guest Insights",
  leftCards = [],
  scoreLabel = "Returning",
  scoreValue = "34%",
  scoreSubLabel = "Guest Ratio",
  progressValue = 34,
}) {
  const { NAVIGATE } = useCommon();
  const { gradients, primary, light, dark } = colors;
  const { cardContent } = gradients;

  const topCards = leftCards.filter((x) => x.fullWidth);
  const bottomCards = leftCards.filter((x) => !x.fullWidth);

  return (
    <Card
      sx={{
        height: "100%",
        p: 1.5,
        // background: linearGradient(
        //   gradients.cardDark.main,
        //   gradients.cardDark.state,
        //   gradients.cardDark.deg
        // ),
      }}
    >
      <VuiBox>
        <VuiTypography variant="lg" fontWeight="bold">
          {title}
        </VuiTypography>

        <VuiBox display="flex" justifyContent="center" mb={1}>
          <VuiBox sx={{ position: "relative", display: "inline-flex" }}>
            <CircularProgress
              variant="determinate"
              value={progressValue}
              size={140}
              thickness={2.5}
              color="success"
            />

            <VuiBox
              sx={{
                inset: 0,
                position: "absolute",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <VuiBox textAlign="center">
                <VuiTypography variant="button" fontWeight="regular">
                  {scoreLabel}
                </VuiTypography>

                <VuiTypography variant="h2" fontWeight="medium" lineHeight={1}>
                  {scoreValue}
                </VuiTypography>

                <VuiTypography variant="button" fontWeight="regular">
                  {scoreSubLabel}
                </VuiTypography>
              </VuiBox>
            </VuiBox>
          </VuiBox>
        </VuiBox>

        {/* Top  card */}
        {topCards.map((card, index) => (
          <VuiBox
            key={index}
            py={1}
            px={2}
            borderRadius="12px"
            mb={1}
            sx={{
              // background: light.secondary,
              border: `1px solid ${rgba(dark.main, 0.25)}`,
            }}
          >
            <VuiBox display="flex" alignItems="center" justifyContent="space-between" mb={1}>
              <VuiBox display="flex" alignItems="center" gap={1}>
                {card.icon}

                <VuiTypography variant="caption">{card.label}</VuiTypography>
              </VuiBox>

              {!!card.route && (
                <VuiBox
                  onClick={() => NAVIGATE(card.route)}
                  sx={{
                    width: 24,
                    height: 24,
                    borderRadius: "8px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    cursor: "pointer",
                    transition: "all 0.2s ease",
                    color: "#A0AEC0",

                    "&:hover": {
                      background: "rgba(255,255,255,0.08)",
                      color: "#fff",
                    },
                  }}
                >
                  <IoOpenOutline size={13} color={dark.main} />
                </VuiBox>
              )}
            </VuiBox>

            <VuiTypography variant="h6" fontWeight="medium">
              {card.value}
            </VuiTypography>
          </VuiBox>
        ))}

        {/* Bottom cards */}
        <Grid container spacing={2}>
          {bottomCards.map((item, index) => (
            <Grid item xs={6} key={index}>
              <VuiBox
                py={1}
                px={2}
                borderRadius="12px"
                sx={{
                  background: light.secondary,
                }}
              >
                <VuiBox display="flex" alignItems="center" gap={1} mb={1}>
                  {item.icon}
                  <VuiTypography variant="caption">{item.label}</VuiTypography>
                </VuiBox>

                <VuiTypography variant="h6" fontWeight="medium" mb={1}>
                  {item.value}
                </VuiTypography>
              </VuiBox>
            </Grid>
          ))}
        </Grid>
      </VuiBox>
    </Card>
  );
}

export default ReferralTracking;
